export default "__VITE_ASSET__DKCR5yAv__"